import { render, staticRenderFns } from "./question_list.vue?vue&type=template&id=08235b1a&scoped=true"
import script from "./question_list.vue?vue&type=script&lang=js"
export * from "./question_list.vue?vue&type=script&lang=js"
import style0 from "./question_list.vue?vue&type=style&index=0&id=08235b1a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08235b1a",
  null
  
)

export default component.exports